import Sohomiami1 from "./sohomiami (1).webp";
import Sohomiami2 from "./sohomiami (2).webp";
import Sohomiami3 from "./sohomiami (3).webp";
import Sohomiami4 from "./sohomiami (4).webp";
import Sohomiami5 from "./sohomiami (5).webp";
import Sohomiami6 from "./sohomiami (6).webp";

const sohomiami = [
  Sohomiami1,
  Sohomiami2,
  Sohomiami3,
  Sohomiami4,
  Sohomiami5,
  Sohomiami6,
];

export default sohomiami;
